/* Scribble Snacks "See it" (P-SEE-IT; Ben 22 Oct 2026: "what will this look like in my space / on me / on my phone").
   Loaded by snippets/ss-see-it.liquid on products whose custom.see_it metafield holds a transparent cutout and its scale
   (tools/see_it.py writes it). Two views:
   - "Size it up": the cutout drawn to scale beside a phone, bank card, hand, mug, A4 page or person, with the real
     measurements, plus a life-size mode calibrated once with a bank card held against the screen.
   - "Try it": the cutout over the shopper's own camera or photo. A dashed phone outline at the same scale lets them
     match it to a real phone for true size. "Save picture" makes a JPEG (shared or downloaded).
   Everything runs in the browser; camera frames and photos never leave the device.
   Source + install: ops/theme-backups/2026-10-22-see-it/ (apply.py). */
(function () {
  'use strict';
  if (window.ssSeeItReady) return;
  window.ssSeeItReady = true;

  var C = { cocoa: '#5A3A2E', cream: '#FFFAF3', butter: '#F7F2A1', straw: '#FFB6CE', strawT: '#FFE9F1',
            lav: '#E6DAF5', lavDk: '#C9B5EA', matcha: '#D5E6C3', apricot: '#FFDDA9', coral: '#EE7466', white: '#FFFFFF' };
  // everyday things, cm, drawn upright (same phone and card sizes as tools/fit_chart.py)
  var REFS = {
    card: { label: 'Bank card', w: 8.6, h: 5.4 },
    phone: { label: 'Phone', note: 'iPhone 18 Pro size', w: 7.2, h: 15.0 },
    hand: { label: 'Hand', w: 10, h: 18.5 },
    mug: { label: 'Mug', w: 12, h: 9.5 },
    a4: { label: 'A4 page', w: 21.0, h: 29.7 },
    person: { label: 'Person', note: '165 cm', w: 46, h: 165 }
  };
  var PXCM_KEY = 'ssSeeItPxPerCm';
  var STRINGS = {
    wear: { open: 'See it on you', tryTab: 'Try it on', tryLead: 'Point your camera at yourself or your outfit, or pick a photo.' },
    space: { open: 'See it in your space', tryTab: 'Try it in your space', tryLead: 'Point your camera at the spot you have in mind, or pick a photo.' },
    phone: { open: 'See it on your phone', tryTab: 'Try it on your phone', tryLead: 'Point your camera at your phone, or pick a photo of it.' }
  };
  var WEAR = ['bag', 'pencilcase', 'makeupcase', 'hairclip', 'keychain', 'wearable'];
  var PHONE = ['phonecase', 'airpodscase'];

  function mode(kind) { return PHONE.indexOf(kind) > -1 ? 'phone' : WEAR.indexOf(kind) > -1 ? 'wear' : 'space'; }
  function fmt(n) { return (Math.round(n * 10) / 10).toString().replace(/\.0$/, ''); }
  function track(ev, extra) {
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'ss_see_it_' + ev }, extra || {})); } catch (e) {}
  }
  function el(tag, attrs, kids) {
    var n = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function (k) {
      if (k === 'text') n.textContent = attrs[k];
      else if (k === 'html') n.innerHTML = attrs[k];
      else if (k.slice(0, 2) === 'on') n.addEventListener(k.slice(2), attrs[k]);
      else n.setAttribute(k, attrs[k]);
    });
    (kids || []).forEach(function (c) { if (c) n.appendChild(c); });
    return n;
  }
  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  function loadCss(href) {
    if (!href || document.querySelector('link[data-ss-seeit-css]')) return;
    document.head.appendChild(el('link', { rel: 'stylesheet', href: href, 'data-ss-seeit-css': '' }));
  }
  function loadImg(src) {
    return new Promise(function (res, rej) {
      var i = new Image();
      i.crossOrigin = 'anonymous'; // Shopify CDN sends CORS headers, so "Save picture" can read the canvas
      i.onload = function () { res(i); };
      i.onerror = rej;
      i.src = src;
    });
  }

  /* ---------- the size entry for the selected variant ---------- */
  function currentSize(data, root) {
    var si = data.si, form = null, id = null;
    var sizes = si.sizes || [];
    if (!sizes.length) return si;
    var sec = root.closest('section, .shopify-section') || document;
    form = sec.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    var inp = form && form.querySelector('[name="id"]');
    id = inp ? String(inp.value) : null;
    var v = (data.variants || []).filter(function (x) { return String(x.id) === id; })[0];
    var opts = v ? v.o.map(function (o) { return String(o).toLowerCase(); }) : [];
    if (v) opts.push(v.o.join(' / ').toLowerCase()); // sizes that depend on two options name the full variant title
    var hit = sizes.filter(function (s) { return s.opt && opts.indexOf(String(s.opt).toLowerCase()) > -1; })[0];
    if (!hit) return si;
    var out = {};
    Object.keys(si).forEach(function (k) { if (k !== 'sizes') out[k] = si[k]; });
    Object.keys(hit).forEach(function (k) { out[k] = hit[k]; });
    return out;
  }
  // whole cutout in cm, and the measured body box in cm inside it
  function geom(s) {
    var pxcm = s.pxcm, b = s.body || [0, 0, s.iw, s.ih];
    return { W: s.iw / pxcm, H: s.ih / pxcm, bx: b[0] / pxcm, by: b[1] / pxcm, bw: b[2] / pxcm, bh: b[3] / pxcm };
  }
  function sizeLabel(s) {
    if (s.label) return s.label;
    var d = s.dims || {};
    var parts = [d.w, d.h, d.d].filter(function (x) { return x; }).map(fmt);
    return parts.length ? 'About ' + parts.join(' x ') + ' cm' : '';
  }

  /* ---------- doodle drawing ---------- */
  function rr(ctx, x, y, w, h, r) {
    r = Math.max(0, Math.min(r, w / 2, h / 2));
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();
  }
  function paint(ctx, fill, lw) {
    ctx.fillStyle = fill; ctx.fill();
    ctx.lineWidth = lw; ctx.strokeStyle = C.cocoa; ctx.lineJoin = 'round'; ctx.stroke();
  }
  // draws reference `key` with its bottom-left corner at (x, yb); s = px per cm
  function drawRef(ctx, key, x, yb, s, lw) {
    var R = REFS[key], w = R.w * s, h = R.h * s, y = yb - h;
    ctx.save();
    if (key === 'phone') {
      rr(ctx, x, y, w, h, 1.1 * s); paint(ctx, C.white, lw);
      rr(ctx, x + 0.35 * s, y + 0.35 * s, w - 0.7 * s, h - 0.7 * s, 0.85 * s); paint(ctx, C.lav, lw * 0.6);
      rr(ctx, x + w / 2 - 1.1 * s, y + 0.75 * s, 2.2 * s, 0.6 * s, 0.3 * s); ctx.fillStyle = C.cocoa; ctx.fill();
    } else if (key === 'card') {
      rr(ctx, x, y, w, h, 0.35 * s); paint(ctx, C.strawT, lw);
      rr(ctx, x + 0.8 * s, y + 1.6 * s, 1.3 * s, 1.0 * s, 0.2 * s); paint(ctx, C.butter, lw * 0.6);
      ctx.beginPath(); ctx.moveTo(x + 0.8 * s, y + h - 1.1 * s); ctx.lineTo(x + w - 2.6 * s, y + h - 1.1 * s);
      ctx.lineWidth = lw * 0.6; ctx.stroke();
    } else if (key === 'hand') {
      var pw = 8.2 * s, ph = 9 * s, px = x + 1.6 * s, py = yb - ph;
      var fl = [6.6, 7.6, 7.1, 5.6], fw = pw / 4;
      ctx.fillStyle = C.apricot; ctx.strokeStyle = C.cocoa; ctx.lineWidth = lw; ctx.lineJoin = 'round';
      for (var i = 0; i < 4; i++) { rr(ctx, px + i * fw + fw * 0.06, py - fl[i] * s + fw / 2, fw * 0.88, fl[i] * s + fw, fw * 0.44); ctx.fill(); ctx.stroke(); }
      ctx.save(); ctx.translate(px + 0.4 * s, py + ph * 0.55); ctx.rotate(-0.75);
      rr(ctx, -1.0 * s, -5.6 * s, 2.0 * s, 6.2 * s, 1.0 * s); ctx.fill(); ctx.stroke(); ctx.restore();
      rr(ctx, px, py, pw, ph, 2.6 * s); ctx.fill(); ctx.stroke();
    } else if (key === 'mug') {
      var mw = 8.6 * s;
      ctx.beginPath(); ctx.ellipse(x + mw + 0.2 * s, y + h * 0.48, 1.9 * s, 2.6 * s, 0, 0, Math.PI * 2);
      ctx.lineWidth = 0.7 * s + lw; ctx.strokeStyle = C.cocoa; ctx.stroke();
      ctx.lineWidth = 0.7 * s - lw * 0.4; ctx.strokeStyle = C.butter; ctx.stroke();
      rr(ctx, x, y, mw, h, 1.1 * s); paint(ctx, C.butter, lw);
      ctx.beginPath(); ctx.arc(x + mw / 2, y + h * 0.5, 1.3 * s, 0, Math.PI * 2); paint(ctx, C.straw, lw * 0.6);
    } else if (key === 'a4') {
      ctx.beginPath(); ctx.moveTo(x, y); ctx.lineTo(x + w - 3 * s, y); ctx.lineTo(x + w, y + 3 * s); ctx.lineTo(x + w, yb); ctx.lineTo(x, yb); ctx.closePath();
      paint(ctx, C.white, lw);
      ctx.lineWidth = lw * 0.5; ctx.strokeStyle = C.matcha;
      for (var l = 1; l < 9; l++) { ctx.beginPath(); ctx.moveTo(x + 2.2 * s, y + (3 + l * 2.8) * s); ctx.lineTo(x + w - 2.2 * s, y + (3 + l * 2.8) * s); ctx.stroke(); }
    } else if (key === 'person') {
      var cx = x + w / 2;
      ctx.fillStyle = C.lav; ctx.strokeStyle = C.cocoa; ctx.lineWidth = lw; ctx.lineJoin = 'round';
      rr(ctx, cx - 15 * s, yb - 84 * s, 13 * s, 84 * s, 6 * s); ctx.fill(); ctx.stroke();
      rr(ctx, cx + 2 * s, yb - 84 * s, 13 * s, 84 * s, 6 * s); ctx.fill(); ctx.stroke();
      rr(ctx, cx - 23 * s, yb - 141 * s, 9 * s, 58 * s, 4.5 * s); ctx.fill(); ctx.stroke();
      rr(ctx, cx + 14 * s, yb - 141 * s, 9 * s, 58 * s, 4.5 * s); ctx.fill(); ctx.stroke();
      rr(ctx, cx - 17 * s, yb - 143 * s, 34 * s, 66 * s, 12 * s); ctx.fill(); ctx.stroke();
      ctx.beginPath(); ctx.arc(cx, yb - 154 * s, 11 * s, 0, Math.PI * 2); ctx.fillStyle = C.apricot; ctx.fill(); ctx.stroke();
    }
    ctx.restore();
  }
  function dimLine(ctx, x1, y1, x2, y2, label, lw, font, vertical) {
    ctx.save();
    ctx.strokeStyle = C.coral; ctx.fillStyle = C.coral; ctx.lineWidth = lw * 0.7; ctx.lineCap = 'round';
    ctx.beginPath(); ctx.moveTo(x1, y1); ctx.lineTo(x2, y2); ctx.stroke();
    var t = lw * 2.4;
    ctx.beginPath();
    if (vertical) { ctx.moveTo(x1 - t, y1); ctx.lineTo(x1 + t, y1); ctx.moveTo(x2 - t, y2); ctx.lineTo(x2 + t, y2); }
    else { ctx.moveTo(x1, y1 - t); ctx.lineTo(x1, y1 + t); ctx.moveTo(x2, y2 - t); ctx.lineTo(x2, y2 + t); }
    ctx.stroke();
    ctx.font = font; ctx.fillStyle = C.cocoa; ctx.textBaseline = 'middle';
    if (vertical) { ctx.textAlign = 'left'; ctx.fillText(label, x1 + t * 1.8, (y1 + y2) / 2); }
    else { ctx.textAlign = 'center'; ctx.fillText(label, (x1 + x2) / 2, y1 + t * 3.2); }
    ctx.restore();
  }
  function pickRef(g) {
    var m = Math.max(g.bw, g.bh);
    return m <= 9 ? 'card' : m <= 32 ? 'phone' : m <= 70 ? 'a4' : 'person';
  }
  function refChoices(g) {
    var m = Math.max(g.W, g.H);
    return Object.keys(REFS).filter(function (k) { return k !== 'person' || m > 35; });
  }

  /* ---------- the dialog ---------- */
  function SeeIt(root, data) {
    this.root = root; this.data = data; this.m = mode(data.si.kind);
    this.S = STRINGS[this.m];
    this.stream = null; this.facing = 'environment';
    this.t = { x: 0, y: 0, k: 10, r: 0 }; this.ptrs = {};
  }
  SeeIt.prototype.build = function () {
    var self = this, S = this.S;
    this.dlg = el('dialog', { class: 'ss-seeit-dlg', 'aria-labelledby': 'ss-seeit-title' });
    this.closeBtn = el('button', { type: 'button', class: 'ss-seeit__x', 'aria-label': 'Close', text: '✕', onclick: function () { self.close(); } });
    this.tabSize = el('button', { type: 'button', class: 'ss-seeit__tab', 'aria-pressed': 'true', text: '📏 Size it up', onclick: function () { self.show('size'); } });
    this.tabTry = el('button', { type: 'button', class: 'ss-seeit__tab', 'aria-pressed': 'false', text: (this.m === 'wear' ? '🤳 ' : '📷 ') + S.tryTab, onclick: function () { self.show('try'); } });

    // size view
    this.sizeLabel = el('p', { class: 'ss-seeit__dims' });
    this.chips = el('div', { class: 'ss-seeit__chips', role: 'group', 'aria-label': 'Compare with' });
    this.canvasWrap = el('div', { class: 'ss-seeit__canvaswrap' });
    this.canvas = el('canvas', { class: 'ss-seeit__canvas', role: 'img' });
    this.canvasWrap.appendChild(this.canvas);
    this.lifeBtn = el('button', { type: 'button', class: 'ss-seeit__btn', text: '🔍 Show life size', onclick: function () { self.toggleLife(); } });
    this.calBtn = el('button', { type: 'button', class: 'ss-seeit__link', text: 'Re-measure my screen', hidden: '', onclick: function () { self.calibrate(); } });
    this.calBox = el('div', { class: 'ss-seeit__cal', hidden: '' });
    this.sizeView = el('div', { class: 'ss-seeit__view' }, [
      this.sizeLabel,
      this.lead = el('p', { class: 'ss-seeit__lead', text: 'Drawn to scale next to everyday things.' }),
      this.chips, this.canvasWrap, this.calBox,
      el('div', { class: 'ss-seeit__row' }, [this.lifeBtn, this.calBtn])
    ]);

    // try view
    this.stage = el('div', { class: 'ss-seeit__stage' });
    this.video = el('video', { class: 'ss-seeit__bg', playsinline: '', muted: '', autoplay: '', hidden: '' });
    this.video.muted = true;
    this.photo = el('img', { class: 'ss-seeit__bg', alt: '', hidden: '' });
    this.empty = el('div', { class: 'ss-seeit__empty' }, [
      el('p', { text: S.tryLead }),
      el('p', { class: 'ss-seeit__small', text: 'Your camera stays on your device. Nothing is uploaded.' })
    ]);
    this.group = el('div', { class: 'ss-seeit__group' });
    this.prodImg = el('img', { class: 'ss-seeit__prod', alt: '', draggable: 'false' });
    this.guide = el('div', { class: 'ss-seeit__guide', 'aria-hidden': 'true' }, [el('span', { text: 'phone' })]);
    this.group.appendChild(this.guide); this.group.appendChild(this.prodImg);
    this.stage.appendChild(this.video); this.stage.appendChild(this.photo); this.stage.appendChild(this.empty); this.stage.appendChild(this.group);
    this.file = el('input', { type: 'file', accept: 'image/*', hidden: '', onchange: function (e) { self.usePhoto(e.target.files && e.target.files[0]); } });
    this.msg = el('p', { class: 'ss-seeit__msg', role: 'status' });
    this.tip = el('p', { class: 'ss-seeit__small ss-seeit__tip' });
    this.guideBtn = el('button', { type: 'button', class: 'ss-seeit__btn ss-seeit__btn--sm', 'aria-pressed': 'true', text: 'Hide phone guide', onclick: function () { self.toggleGuide(); } });
    this.snapBtn = el('button', { type: 'button', class: 'ss-seeit__btn ss-seeit__btn--go', text: '📸 Save picture', disabled: '', onclick: function () { self.snap(); } });
    this.tryView = el('div', { class: 'ss-seeit__view', hidden: '' }, [
      el('div', { class: 'ss-seeit__row' }, [
        el('button', { type: 'button', class: 'ss-seeit__btn', text: '📷 Camera', onclick: function () { self.startCam('environment'); } }),
        el('button', { type: 'button', class: 'ss-seeit__btn', text: '🤳 Selfie', onclick: function () { self.startCam('user'); } }),
        el('button', { type: 'button', class: 'ss-seeit__btn', text: '🖼️ Photo', onclick: function () { self.file.click(); } })
      ]),
      this.stage, this.msg,
      el('div', { class: 'ss-seeit__row' }, [
        el('button', { type: 'button', class: 'ss-seeit__btn ss-seeit__btn--sm', 'aria-label': 'Smaller', text: '−', onclick: function () { self.zoom(1 / 1.08); } }),
        el('button', { type: 'button', class: 'ss-seeit__btn ss-seeit__btn--sm', 'aria-label': 'Bigger', text: '+', onclick: function () { self.zoom(1.08); } }),
        el('button', { type: 'button', class: 'ss-seeit__btn ss-seeit__btn--sm', 'aria-label': 'Turn', text: '↻', onclick: function () { self.t.r += Math.PI / 12; self.place(); } }),
        this.guideBtn, this.snapBtn
      ]),
      this.tip, this.file
    ]);

    this.dlg.appendChild(el('div', { class: 'ss-seeit__card' }, [
      el('div', { class: 'ss-seeit__head' }, [
        el('h2', { id: 'ss-seeit-title', class: 'ss-seeit__title', text: 'See it' }),
        el('p', { class: 'ss-seeit__sub', text: this.data.title || '' }),
        this.closeBtn
      ]),
      el('div', { class: 'ss-seeit__tabs' }, [this.tabSize, this.tabTry]),
      this.sizeView, this.tryView,
      el('p', { class: 'ss-seeit__small ss-seeit__foot', text: 'Sizes are approximate and measured on the product itself (straps and chains not counted).' })
    ]));
    this.dlg.addEventListener('close', function () { self.stopCam(); });
    this.dlg.addEventListener('click', function (e) { if (e.target === self.dlg) self.close(); });
    document.body.appendChild(this.dlg);
    this.bindStage();
    window.addEventListener('resize', function () { if (self.dlg.open) { if (self.view === 'size') self.drawSize(); else self.fitStage(); } });
  };
  SeeIt.prototype.open = function () {
    var self = this;
    if (!this.dlg) this.build();
    this.s = currentSize(this.data, this.root);
    this.g = geom(this.s);
    this.ref = this.ref && refChoices(this.g).indexOf(this.ref) > -1 ? this.ref : pickRef(this.g);
    this.sizeLabel.textContent = sizeLabel(this.s);
    this.prodImg.alt = (this.data.title || 'Product') + ', cut out';
    this.renderChips();
    this.msg.textContent = '';
    if (this.dlg.showModal) this.dlg.showModal(); else this.dlg.setAttribute('open', '');
    this.closeBtn.focus();
    this.show(this.view || 'size');
    track('open', { see_it_kind: this.data.si.kind });
    if (this.img && this.img.src !== this.s.img) this.img = null; // another variant's photo: never draw the old one at the new size
    loadImg(this.s.img).then(function (img) {
      self.img = img; self.prodImg.src = img.src; self.drawSize(); self.fitStage();
    }).catch(function () { self.msg.textContent = "Sorry, the picture didn't load. Please try again."; });
  };
  SeeIt.prototype.close = function () {
    this.stopCam();
    if (this.dlg.close) this.dlg.close(); else this.dlg.removeAttribute('open');
  };
  SeeIt.prototype.show = function (v) {
    this.view = v;
    this.tabSize.setAttribute('aria-pressed', v === 'size'); this.tabTry.setAttribute('aria-pressed', v === 'try');
    this.sizeView.hidden = v !== 'size'; this.tryView.hidden = v !== 'try';
    if (v === 'size') { this.stopCam(); this.drawSize(); } else { this.fitStage(); track('try'); }
  };
  SeeIt.prototype.renderChips = function () {
    var self = this;
    this.chips.innerHTML = '';
    refChoices(this.g).forEach(function (k) {
      self.chips.appendChild(el('button', { type: 'button', class: 'ss-seeit__chip', 'aria-pressed': String(k === self.ref), text: REFS[k].label,
        onclick: function () { self.ref = k; self.renderChips(); self.drawSize(); track('ref', { see_it_ref: k }); } }));
    });
  };

  /* size it up */
  SeeIt.prototype.drawSize = function () {
    if (!this.img || this.view !== 'size') return;
    // life size: the product alone at true size on this (calibrated) screen; otherwise a scaled drawing beside a reference
    var g = this.g, life = !!(this.life && this.pxcm), R = life ? null : REFS[this.ref];
    var dpr = Math.min(window.devicePixelRatio || 1, 3);
    var cw = this.canvasWrap.clientWidth || 320, pad = 18, labelSpace = 42;
    var refW = R ? R.w : 0, refH = R ? R.h : 0, gap = R ? Math.max(1.5, 0.12 * Math.max(R.w, g.W)) : 0;
    var s, CW, CH;
    if (life) {
      s = this.pxcm;
      CW = Math.max(cw, g.W * s + 2 * pad + 70);
      CH = g.H * s + 2 * pad + labelSpace;
    } else {
      var ch = Math.min(Math.max(cw * 0.78, 240), 440);
      s = Math.min((cw - 2 * pad - 60) / (refW + gap + g.W), (ch - 2 * pad - labelSpace) / Math.max(refH, g.H));
      CW = cw; CH = ch;
    }
    var cv = this.canvas, ctx = cv.getContext('2d');
    cv.width = Math.round(CW * dpr); cv.height = Math.round(CH * dpr);
    cv.style.width = CW + 'px'; cv.style.height = CH + 'px';
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, CW, CH);
    var base = CH - pad - labelSpace, lw = Math.max(1.5, Math.min(3, s * 0.12));
    var font = '600 13px ' + (getComputedStyle(document.body).fontFamily || 'sans-serif');
    var total = (refW + gap + g.W) * s, x0 = Math.max(pad, (CW - 60 - total) / 2);
    // ground line
    ctx.save(); ctx.strokeStyle = 'rgba(90,58,46,.25)'; ctx.setLineDash([6, 6]); ctx.lineWidth = 1.5;
    ctx.beginPath(); ctx.moveTo(pad / 2, base + 1); ctx.lineTo(CW - pad / 2, base + 1); ctx.stroke(); ctx.restore();
    if (R) {
      drawRef(ctx, this.ref, x0, base, s, lw);
      // reference name under it (note on a second, smaller line), kept inside the canvas
      ctx.fillStyle = C.cocoa; ctx.textAlign = 'center'; ctx.textBaseline = 'top';
      var cx = x0 + R.w * s / 2, lines = [[font, R.label]];
      if (R.note) lines.push([font.replace('600 13px', '400 11px'), R.note]);
      lines.forEach(function (ln, i) {
        ctx.font = ln[0];
        var tw = ctx.measureText(ln[1]).width;
        ctx.fillText(ln[1], Math.max(4 + tw / 2, Math.min(CW - 4 - tw / 2, cx)), base + 8 + i * 15);
      });
    }
    // product, standing on the line
    var px = x0 + (refW + gap) * s, py = base - g.H * s;
    ctx.drawImage(this.img, px, py, g.W * s, g.H * s);
    var d = this.s.dims || {}, bx = px + g.bx * s, by = py + g.by * s, bw = g.bw * s, bh = g.bh * s;
    var showW = d.w || (this.s.basis === 'longest' && g.bw >= g.bh ? d.longest : null);
    var showH = d.h || (this.s.basis === 'longest' && g.bh > g.bw ? d.longest : null);
    if (showW) dimLine(ctx, bx, base + 12, bx + bw, base + 12, fmt(showW) + ' cm', lw, font, false);
    if (showH) dimLine(ctx, px + g.W * s + 10, by, px + g.W * s + 10, by + bh, fmt(showH) + ' cm', lw, font, true);
    this.canvas.setAttribute('aria-label', (this.data.title || 'This product') + ', ' + sizeLabel(this.s) +
      (R ? ', drawn to scale next to a ' + R.label.toLowerCase() : ', shown at life size'));
    this.canvasWrap.classList.toggle('is-life', life);
    var screenCm = cw / s;
    this.lead.textContent = !life ? 'Drawn to scale next to everyday things.'
      : (g.bw <= screenCm && g.bh * s <= (window.innerHeight || 700) * 0.6)
        ? 'Life size on your screen. Hold things up to it to compare.'
        : "Life size! It's bigger than this screen (about " + fmt(screenCm) + ' cm across), so scroll around to see it all.';
    if (life) {  // bring the product's body into view when it's bigger than the screen
      var wrap = this.canvasWrap;
      wrap.scrollLeft = Math.max(0, bx + bw / 2 - wrap.clientWidth / 2);
      wrap.scrollTop = Math.max(0, by + bh / 2 - wrap.clientHeight / 2);
    }
  };
  SeeIt.prototype.toggleLife = function () {
    if (this.life) { this.life = false; this.lifeBtn.textContent = '🔍 Show life size'; this.calBox.hidden = true; this.chips.hidden = false; this.drawSize(); return; }
    this.pxcm = parseFloat(lsGet(PXCM_KEY)) || 0;
    if (!this.pxcm) { this.calibrate(); return; }
    this.life = true; this.lifeBtn.textContent = 'Back to the drawing'; this.calBtn.hidden = false;
    this.chips.hidden = true;
    this.drawSize(); track('life');
  };
  SeeIt.prototype.calibrate = function () {
    var self = this;
    var guess = parseFloat(lsGet(PXCM_KEY)) || (96 / 2.54) * (window.matchMedia && matchMedia('(pointer:coarse)').matches ? 1.45 : 1);
    var card = el('div', { class: 'ss-seeit__calcard' });
    var range = el('input', { type: 'range', min: '12', max: '90', step: '0.1', value: String(guess), 'aria-label': 'Card size' });
    function upd() { var v = parseFloat(range.value); card.style.width = (8.56 * v) + 'px'; card.style.height = (5.398 * v) + 'px'; }
    range.addEventListener('input', upd);
    this.calBox.innerHTML = '';
    this.calBox.appendChild(el('p', { text: 'Quick screen check: hold a bank card flat against your screen and slide until the pink card is exactly the same size.' }));
    this.calBox.appendChild(card); this.calBox.appendChild(range);
    this.calBox.appendChild(el('button', { type: 'button', class: 'ss-seeit__btn ss-seeit__btn--go', text: 'Looks right',
      onclick: function () { lsSet(PXCM_KEY, range.value); self.pxcm = parseFloat(range.value); self.calBox.hidden = true; self.life = false; self.toggleLife(); } }));
    this.calBox.hidden = false; upd();
    card.scrollIntoView && card.scrollIntoView({ block: 'nearest' });
  };

  /* try it */
  SeeIt.prototype.fitStage = function () {
    if (!this.img || this.view !== 'try') return;
    var W = this.stage.clientWidth, H = this.stage.clientHeight;
    if (!W || !H) return;
    if (!this.placed) {
      this.t.k = (H * 0.42) / Math.max(this.g.H, REFS.phone.h * 0.9);
      this.t.x = W * 0.58; this.t.y = H * 0.55; this.t.r = 0; this.placed = true;
      this.tip.textContent = 'Drag to move, pinch or use + and − to resize. For true size, line the dashed phone up with a real phone, then hide the guide.';
    }
    this.place();
  };
  SeeIt.prototype.place = function () {
    var t = this.t, g = this.g;
    this.group.style.width = (g.W * t.k) + 'px'; this.group.style.height = (g.H * t.k) + 'px';
    this.group.style.transform = 'translate(' + t.x + 'px,' + t.y + 'px) translate(-50%,-50%) rotate(' + t.r + 'rad)';
    var pw = REFS.phone.w * t.k, ph = REFS.phone.h * t.k;
    this.guide.style.width = pw + 'px'; this.guide.style.height = ph + 'px';
    this.guide.style.left = (-(pw + 1.2 * t.k)) + 'px'; this.guide.style.top = (g.H * t.k - ph) + 'px';
  };
  SeeIt.prototype.zoom = function (f) {
    this.t.k = Math.max(0.4, Math.min(120, this.t.k * f)); this.place();
  };
  SeeIt.prototype.toggleGuide = function () {
    var on = this.guide.hidden; this.guide.hidden = !on;
    this.guideBtn.setAttribute('aria-pressed', String(on));
    this.guideBtn.textContent = on ? 'Hide phone guide' : 'Show phone guide';
  };
  SeeIt.prototype.bindStage = function () {
    var self = this, st = this.stage;
    function pt(e) { var r = st.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; }
    st.addEventListener('pointerdown', function (e) {
      if (!self.img) return;
      st.setPointerCapture && st.setPointerCapture(e.pointerId);
      self.ptrs[e.pointerId] = pt(e);
    });
    st.addEventListener('pointermove', function (e) {
      var prev = self.ptrs[e.pointerId];
      if (!prev) return;
      var now = pt(e), ids = Object.keys(self.ptrs);
      if (ids.length === 1) {
        self.t.x += now.x - prev.x; self.t.y += now.y - prev.y;
      } else if (ids.length >= 2) {
        var other = self.ptrs[ids[0] === String(e.pointerId) ? ids[1] : ids[0]];
        var d0 = Math.hypot(prev.x - other.x, prev.y - other.y), d1 = Math.hypot(now.x - other.x, now.y - other.y);
        var a0 = Math.atan2(prev.y - other.y, prev.x - other.x), a1 = Math.atan2(now.y - other.y, now.x - other.x);
        if (d0 > 4) self.t.k = Math.max(0.4, Math.min(120, self.t.k * d1 / d0));
        self.t.r += a1 - a0;
        self.t.x += (now.x - prev.x) / 2; self.t.y += (now.y - prev.y) / 2;
      }
      self.ptrs[e.pointerId] = now; self.place();
    });
    function up(e) { delete self.ptrs[e.pointerId]; }
    st.addEventListener('pointerup', up); st.addEventListener('pointercancel', up); st.addEventListener('pointerleave', up);
    st.addEventListener('wheel', function (e) { e.preventDefault(); self.zoom(Math.exp(-e.deltaY * 0.0015)); }, { passive: false });
  };
  SeeIt.prototype.startCam = function (facing) {
    var self = this;
    this.msg.textContent = '';
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) { this.msg.textContent = "Your browser can't open the camera here. Try a photo instead!"; return; }
    this.stopCam();
    navigator.mediaDevices.getUserMedia({ video: { facingMode: { ideal: facing }, width: { ideal: 1280 }, height: { ideal: 960 } }, audio: false })
      .then(function (stream) {
        self.stream = stream; self.facing = facing;
        self.video.srcObject = stream; self.video.hidden = false; self.photo.hidden = true; self.empty.hidden = true;
        self.video.classList.toggle('is-mirror', facing === 'user');
        self.video.play && self.video.play().catch(function () {});
        self.snapBtn.disabled = false; self.fitStage(); track('camera', { see_it_facing: facing });
      })
      .catch(function () { self.msg.textContent = "We couldn't open the camera (it may be blocked). Try a photo instead!"; });
  };
  SeeIt.prototype.stopCam = function () {
    if (this.stream) { this.stream.getTracks().forEach(function (t) { t.stop(); }); this.stream = null; }
    if (this.video) { this.video.srcObject = null; this.video.hidden = true; }
    if (this.video && this.photo && this.photo.hidden && this.empty) { this.empty.hidden = false; this.snapBtn.disabled = true; }
  };
  SeeIt.prototype.usePhoto = function (f) {
    var self = this;
    if (!f) return;
    this.stopCam();
    if (this.photoUrl) URL.revokeObjectURL(this.photoUrl);
    this.photoUrl = URL.createObjectURL(f);
    this.photo.onload = function () { self.photo.hidden = false; self.empty.hidden = true; self.snapBtn.disabled = false; self.fitStage(); };
    this.photo.src = this.photoUrl; this.file.value = '';
    track('photo');
  };
  function cover(sw, sh, dw, dh) {
    var r = Math.max(dw / sw, dh / sh), w = dw / r, h = dh / r;
    return { sx: (sw - w) / 2, sy: (sh - h) / 2, sw: w, sh: h };
  }
  SeeIt.prototype.snap = function () {
    var self = this, W = this.stage.clientWidth, H = this.stage.clientHeight;
    var f = Math.min(2, 1600 / Math.max(W, H)), cv = document.createElement('canvas');
    cv.width = Math.round(W * f); cv.height = Math.round(H * f);
    var ctx = cv.getContext('2d');
    ctx.fillStyle = C.cream; ctx.fillRect(0, 0, cv.width, cv.height);
    var src = !this.video.hidden ? this.video : !this.photo.hidden ? this.photo : null;
    if (src) {
      var sw = src.videoWidth || src.naturalWidth, sh = src.videoHeight || src.naturalHeight, c = cover(sw, sh, cv.width, cv.height);
      ctx.save();
      if (src === this.video && this.video.classList.contains('is-mirror')) { ctx.translate(cv.width, 0); ctx.scale(-1, 1); }
      ctx.drawImage(src, c.sx, c.sy, c.sw, c.sh, 0, 0, cv.width, cv.height);
      ctx.restore();
    }
    var t = this.t, g = this.g;
    ctx.save(); ctx.scale(f, f); ctx.translate(t.x, t.y); ctx.rotate(t.r);
    ctx.drawImage(this.img, -g.W * t.k / 2, -g.H * t.k / 2, g.W * t.k, g.H * t.k);
    ctx.restore();
    var fs = Math.round(cv.width * 0.035);
    ctx.font = '700 ' + fs + 'px ' + (getComputedStyle(document.body).fontFamily || 'sans-serif');
    ctx.textAlign = 'right'; ctx.textBaseline = 'bottom'; ctx.lineJoin = 'round';
    ctx.lineWidth = fs * 0.22; ctx.strokeStyle = C.cocoa; ctx.strokeText('scribblesnacks.com', cv.width - fs * 0.6, cv.height - fs * 0.5);
    ctx.fillStyle = C.white; ctx.fillText('scribblesnacks.com', cv.width - fs * 0.6, cv.height - fs * 0.5);
    try {
      cv.toBlob(function (blob) {
        if (!blob) { self.msg.textContent = "Sorry, that picture couldn't be saved."; return; }
        var name = 'scribble-snacks-see-it.jpg', file = window.File ? new File([blob], name, { type: 'image/jpeg' }) : null;
        if (file && navigator.canShare && navigator.canShare({ files: [file] })) {
          navigator.share({ files: [file], title: self.data.title || 'Scribble Snacks' }).catch(function () {});
        } else {
          var a = el('a', { href: URL.createObjectURL(blob), download: name });
          document.body.appendChild(a); a.click(); setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 4000);
        }
        self.msg.textContent = 'Saved! Tag us @scribble.snacks if you share it 💕';
        track('snap');
      }, 'image/jpeg', 0.9);
    } catch (e) { self.msg.textContent = "Sorry, that picture couldn't be saved."; }
  };

  /* ---------- wire up every button on the page ---------- */
  function init(root) {
    if (root.dataset.ssSeeitOn) return;
    root.dataset.ssSeeitOn = '1';
    var raw = root.querySelector('script[data-ss-seeit-data]');
    var data; try { data = JSON.parse(raw.textContent); } catch (e) { return; }
    if (!data || !data.si || !data.si.img) return;
    var btn = root.querySelector('.ss-seeit__open'), app = new SeeIt(root, data);
    var lbl = root.querySelector('.ss-seeit__label');
    if (lbl) lbl.textContent = STRINGS[app.m].open;
    loadCss(root.dataset.css); // small and async, so the dialog never opens unstyled
    btn.hidden = false;
    btn.addEventListener('click', function () { app.open(); });
  }
  function scan() { document.querySelectorAll('[data-ss-seeit]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();
